import { supabase } from '../supabase';

/**
 * Estrae bucket e path da un URL storage Supabase.
 *
 * Funziona sia con URL signed (`/storage/v1/object/sign/<bucket>/<path>?token=...`)
 * sia public (`/storage/v1/object/public/<bucket>/<path>`). Il path interno è
 * identico tra progetti (es. Ohio → EU), quindi il dominio dell'URL è irrilevante:
 * conta solo il path, che usiamo per rigenerare un signed URL fresco.
 */
export function extractStoragePath(url: string): { bucket: string; path: string } | null {
  try {
    const { pathname } = new URL(url);
    // /storage/v1/object/{sign|public}/<bucket>/<path...>
    const parts = pathname.split('/');
    if (parts.length >= 7) {
      const bucket = parts[5];
      const path = decodeURIComponent(parts.slice(6).join('/'));
      return { bucket, path };
    }
    return null;
  } catch {
    return null;
  }
}

/**
 * Rigenera un signed URL fresco a partire da un URL storage salvato in DB.
 *
 * Gli URL salvati in `deals.signed_contract_url` / `unsigned_contract_url` sono
 * signed URL a scadenza, spesso scaduti e/o puntati al vecchio progetto Ohio.
 * Estraendo il path e rifirmando su EU otteniamo un link valido.
 *
 * In caso di estrazione/firma fallita ritorna l'URL originale (fallback).
 */
export async function getFreshContractUrl(url: string, ttl = 3600): Promise<string> {
  const extracted = extractStoragePath(url);
  if (!extracted) return url;

  try {
    const { data, error } = await supabase.storage
      .from(extracted.bucket)
      .createSignedUrl(extracted.path, ttl);

    if (error || !data?.signedUrl) return url;
    return data.signedUrl;
  } catch {
    return url;
  }
}
